import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './ImportLogField.css';

const ImportLogField = ({ name, placeholder, logs, showNbActivated, single }) => {
    const { t } = useTranslation();

    const options = logs.map(log => {
        return {
            key: log._id,
            text: (
                <div className="log-option">
                    <img src={log.sourceIcone()} className="img rounded mr-2" />
                    { `${log.created_at.format('LLL')} (${log[showNbActivated ? 'activated' : 'inserted']?.length || 0})` }
                </div>
            ),
            value: log._id,
        };
    });

    const input = single ? (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ placeholder }
            clearable
        />
    ) : (
        <MultiSelectField name={ name } options={ options } placeholder={ placeholder } clearable />
    );

    return (
        <div className="ImportLogField">
            { input }
        </div>
    );
}

export default ImportLogField;
